/**
 * 表示用フォーマッタ（AppShell / Dashboard 共通）
 */

/** 残高の表示値。Home・Short の displayBalance（ceilCredits(max(balance, 0))＝5単位繰上げ・負は0）と揃える */
export const displayCredits = (balance: number) => Math.ceil(Math.max(balance, 0) / 5) * 5
